import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/HomePage.vue'; // 导入首页组件
import BrandInfo from '../views/about/BrandInfo.vue'; // 导入BrandInfo组件
import BrandCulture from '../views/about/BrandCulture.vue'; // 导入BrandInfo组件
import BrandInformation from '../views/about/BrandInformation.vue'; // 导入BrandInfo组件
import ProductDetailPage from '../views/ProductDetailPage.vue'; // 导入产品详情页组件
import Contract from '../views/contract.vue'; // 导入产品详情页组件
import AntiFake from '../views/AntiFake.vue'; // 导入产品详情页组件
import BuyPage from '../views/BuyPage.vue'; // 导入购买页面组件
import NewsList from '../views/NewsList';
import NewsDetail from '../views/NewsDetail';



Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home // 指定首页组件
    },
    {
        path: '/brand-info',
        name: 'BrandInfo',
        component: BrandInfo
    },
    {
        path: '/brand-culture',
        name: 'BrandCulture',
        component: BrandCulture
    },
    {
        path: '/brand-information',
        name: 'BrandInformation',
        component: BrandInformation
    },
    {
        path: '/product/:productId', // 动态参数 :productId
        name: 'ProductDetail',
        component: ProductDetailPage
    },
    {
        path: '/Contract', // 动态参数 :productId
        name: 'Contract',
        component: Contract
    },
    {
        path: '/AntiFake', // 动态参数 :productId
        name: 'AntiFake',
        component: AntiFake
    },
    {
        path: '/buy/:productId',
        name: 'BuyPage',
        component: BuyPage
    },
    {
        path: '/news',
        name: 'NewsList',
        component: NewsList
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetail
    }
    // 其他路由配置
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;
